// Layout Skins(used by all pages
import './css/bootstrap.min.css';
import './css/fontawesome.5.7.2.css';
import './css/flaticon.css';
import './css/animate.css';
import './css/owl.carousel.min.css';
import './css/magnific-popup.css';
import './css/style.css';
import './css/responsive.css';